import {
  Box,
  Button,
  IconButton,
  Paper,
  Typography,
  styled,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

export const DialogBody = styled(Box)({
  flexDirection: "column",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flex: 1,
  minWidth: "600px",
  maxWidth: "600px",
  width: "100%",
})

export const DialogHeader = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  padding: "12px 15px 0px 15px",
})

export const DialogContent = styled(Box)({
  display: "flex",
  alignItems: "stretch",
  gap: "10px",
  justifyContent: "space-between",
  width: "100%",
  padding: "10px 15px 15px 15px",
})

export const DialogItem = styled(Box)({
  display: "flex",
  alignItems: "center",
  // width: "100%",
})

export const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
})
export const DialogFooter = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  justifyContent: "flex-end",
  width: "100%",
  padding: "0px 15px 0px 15px",
  marginBottom: "10px",
})

export const StyledButton = styled(Button)({
  fontWeight: "bold",
  padding: "5px 35px",
})

export const FileBox = (props: any) => {
  const { file, removeHandler, sx, disable } = props
  const { name, size, type } = file || {}

  return (
    <Paper
      elevation={3}
      sx={{
        display: "flex",
        width: "90%",
        flexDirection: "column",
        backgroundColor: "#fff",
        borderRadius: "5px",
        mx: "auto",
        px: "10px",
        py: "5px",
        gap: "3px",
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: "bold",
            overflow: "hidden",
            maxWidth: "100px",
          }}
        >
          {name}
        </Typography>
        {!disable && (
          <IconButton disableTouchRipple sx={{ p: 0 }} onClick={removeHandler}>
            <CloseIcon sx={{ fontSize: "15px" }} />
          </IconButton>
        )}
      </Box>
      {size && (
        <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
          Size : {size}
        </Typography>
      )}
      {type && (
        <Typography
          sx={{ fontSize: "10px", fontWeight: "bold", overflow: "hidden" }}
        >
          Type : {type}
        </Typography>
      )}
    </Paper>
  )
}
